import { render, staticRenderFns } from "./p-packages-edit-version-popup.vue?vue&type=template&id=0ff3580e&scoped=true"
import script from "./p-packages-edit-version-popup.vue?vue&type=script&lang=js"
export * from "./p-packages-edit-version-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3580e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff3580e')) {
      api.createRecord('0ff3580e', component.options)
    } else {
      api.reload('0ff3580e', component.options)
    }
    module.hot.accept("./p-packages-edit-version-popup.vue?vue&type=template&id=0ff3580e&scoped=true", function () {
      api.rerender('0ff3580e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/popups/p-packages-edit-version-popup/p-packages-edit-version-popup.vue"
export default component.exports